import './Footer.css';
import logo from '../../assets/logo.png';

const Footer = () => {
  const handleWhatsAppClick = () => {
    const phoneNumber = '5531972035157';
    const message = 'Olá, gostaria de fazer um orçamento de painéis de LED.';
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__grid">
          <div className="footer__brand">
            <img src={logo} alt="ACJ Locações" className="footer__logo" />
            <p>
              Soluções profissionais em painéis de LED para eventos, shoppings, igrejas,
              publicidade e comunicação visual. +10 anos transformando espaços em experiências inesquecíveis.
            </p>
            <div className="footer__social">
              <a
                href="https://www.instagram.com/acjlocacoes/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <i className="fab fa-instagram"></i>
              </a>
              <a
                href="#"
                onClick={(e) => { e.preventDefault(); handleWhatsAppClick(); }}
                aria-label="WhatsApp"
              >
                <i className="fab fa-whatsapp"></i>
              </a>
            </div>
          </div>

          <div className="footer__section">
            <h4>Navegação</h4>
            <ul>
              <li><a href="#servicos">Serviços</a></li>
              <li><a href="#portfolio">Portfolio</a></li>
              <li><a href="#depoimentos">Depoimentos</a></li>
              <li><a href="#contato">Contato</a></li>
            </ul>
          </div>

          <div className="footer__section">
            <h4>Serviços</h4>
            <ul>
              <li><a href="#servicos">Eventos Corporativos</a></li>
              <li><a href="#servicos">Shows e Festivais</a></li>
              <li><a href="#servicos">Festas e Casamentos</a></li>
              <li><a href="#servicos">Shoppings e Varejo</a></li>
              <li><a href="#servicos">Igrejas</a></li>
              <li><a href="#servicos">Publicidade e Outdoor</a></li>
            </ul>
          </div>

          <div className="footer__section">
            <h4>Contato</h4>
            <ul>
              <li>
                <a href="https://wa.me/5531972035157" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-whatsapp"></i>
                  (31) 97203-5157
                </a>
              </li>
              <li>
                <span>
                  <i className="fas fa-map-marker-alt"></i>
                  Belo Horizonte, MG
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer__bottom">
          <p>&copy; {new Date().getFullYear()} ACJ Locações - Todos os direitos reservados</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
